export default "__VITE_ASSET__DpGwPkOq__"